import React, { useState } from "react";
import { ModalBody, Modal, Button } from "reactstrap";
import { useDispatch } from 'react-redux';
import { logout } from 'service/users/action';

const LogoutModal = ({ isModalOpen, updateModal }) => {
  const dispatch = useDispatch();
  const onLogout = () => {
    dispatch(logout())
    updateModal();
  };
  return (
    <Modal isOpen={isModalOpen} centered size="xl" scrollable style={{ width: "500px" }}>
      <ModalBody>
        <p style={{ marginLeft: "110px" }}>Are you sure, you want to logout ?</p>
        <Button style={{ marginLeft: "170px" }} onClick={() => onLogout()}>YES</Button>
        <Button style={{ marginLeft: "20px" }} onClick={() => updateModal()}>NO</Button>
      </ModalBody>
    </Modal>
  );
};

export default LogoutModal;